import {
  Card, CardContent, CircularProgress, Container, Divider,
  List, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText,
  Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography
} from '@material-ui/core';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import MoneyIcon from '@material-ui/icons/Money';
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { PullToRefresh } from 'react-js-pull-to-refresh';
import { useHistory } from 'react-router';
import MoneyDisplay from 'src/components/MoneyDisplay';
import Page from 'src/components/Page';
import { GetSiriusTodaySummary } from 'src/store/api/tasks';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  },
  tableD: {
    maxWidth: '100%',
    tableLayout: 'fixed',
  },
  tableRow: {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  contentD: {
    padding: 0
  },
  dividerD: {
    backgroundColor: '#1D3343'
  },
}));


const tahsilatDefault = {
  Adet: 0,
  Nakit: 0.00,
  KrediKarti: 0.00,
  Senet: 0.00,
  Borc: 0.00,
  Diger: 0.00,
  Toplam: 0.00,
  EkGaranti: 0.00,
  TamamlayiciUrun: 0.00
};
const tahsilatlarDefault = [tahsilatDefault, tahsilatDefault];

function Tahsilat({ today }) {
  const { t } = useTranslation('today_summary');
  const [todosData, setTodosData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tahsilat, setTahsilat] = useState(tahsilatlarDefault);

  const history = useHistory();

  // useEffect(() => {
  //   fetchTodos();
  //   // eslint-disable-next-line
  // }, []);

  // const onRefresh = () => {
  //   return new Promise((resolve) => {
  //     setTimeout(resolve, 50);
  //     fetchTodos();
  //   });
  // }

  // const fetchTodos = () => {
  //   setLoading(true);
  //   GetSiriusTodaySummary()
  //     .then(response => {
  //       let data = response.data;
  //       if (data.length === 0) {
  //         setTahsilat(tahsilatlarDefault);
  //         setTodosData([]);
  //         setLoading(false);
  //         return;
  //       }
  //       let tempTahsilat = [];
  //       // dün ve bugün için para toplamlarını ayrıştırmak gerekiyor
  //       let gunler = [0, 1]; // 0 : dün,  1: bugün
  //       gunler.forEach(gun => {
  //         let Adet = 0;
  //         let Nakit = 0.00;
  //         let KrediKarti = 0.00;
  //         let Senet = 0.00;
  //         let Borc = 0.00;
  //         let Diger = 0.00;
  //         let Toplam = 0.00;
  //         let EkGaranti = 0.00;
  //         let TamamlayiciUrun = 0.00;

  //         data.filter(f => f.OperationStartDate === gun).forEach(d => {
  //           Adet += 1;
  //           switch (d.Payment) {
  //             case "Nakit":
  //               Nakit += d.Price || 0;
  //               break;
  //             case "Kredi kartı":
  //               KrediKarti += d.Price || 0;
  //               break;
  //             case "Senet":
  //               Senet += d.Price || 0;
  //               break;
  //             case "Borç":
  //               Borc += d.Price || 0;
  //               break;
  //             case "Diğer":
  //               Diger += d.Price || 0;
  //               break;
  //             default:
  //               break;
  //           }
  //           Toplam += d.Price || 0;
  //           if (d.Type === 3) {
  //             EkGaranti += d.Price || 0;
  //           }
  //           if (d.Type === 2) {
  //             TamamlayiciUrun += d.Price || 0;
  //           }
  //         });
  //         tempTahsilat.push({
  //           Adet: Adet,
  //           Nakit: Nakit,
  //           KrediKarti: KrediKarti,
  //           Senet: Senet,
  //           Borc: Borc,
  //           Diger: Diger,
  //           Toplam: Toplam,
  //           EkGaranti: EkGaranti,
  //           TamamlayiciUrun: TamamlayiciUrun
  //         });
  //       });
  //       setTahsilat(tempTahsilat);
  //       setTodosData(data);
  //       setLoading(false);
  //     }).catch(error => {
  //       setTahsilat(tahsilatlarDefault);
  //       setTodosData([]);
  //       setLoading(false);
  //     });
  // }


  const classes = useStyles();
  return (
    <Page className={classes.root} title={'Sirius Tech'}>
      <Container maxWidth="lg">
        {/* <PullToRefresh
          pullDownContent={<CircularProgress status={'loading'} style={{ marginLeft: '44%' }} />}
          releaseContent={<CircularProgress status={'loading'} style={{ marginLeft: '44%' }} />}
          refreshContent={<CircularProgress status={'loading'} style={{ marginLeft: '44%' }} />}
          pullDownThreshold={101}
          onRefresh={onRefresh}
          triggerHeight={501}
          startInvisible={true}
        >
          <div style={{ minHeight: 400, textAlign: 'center' }}>
            <div className={clsx(classes.root, classes.todos)}>
              <Card> */}
        {/* <Divider />
                {
                  loading ?
                    <CircularProgress color="primary" />
                    : <div></div>
                } */}
        {/* <CardContent className={classes.contentD}>
                  <List className={classes.root}>
                    <ListItem>
                      <Typography variant="h6" gutterBottom>
                        You have <b style={{ color: '#FF0000' }}>{tahsilat[today].Adet}</b> work orders with an appointment for {today === 1 ? "today" : "yesterday"}
                      </Typography>
                    </ListItem>
                  </List>
                  <Divider className={classes.dividerD} />
                  <List>
                    {[
                      { value: tahsilat[today].Nakit, text: t('Nakit'), icon: <MoneyIcon /> },
                      { value: tahsilat[today].KrediKarti, text: t('Kredi_Karti'), icon: <CreditCardIcon /> },
                      { value: tahsilat[today].Senet, text: t('Senet'), icon: <AccountBalanceWalletIcon /> },
                      { value: tahsilat[today].Borc, text: t('Borc'), icon: <MoneyOffIcon /> },
                      { value: tahsilat[today].Diger, text: t('Diger'), icon: <AccountBalanceIcon /> },
                      { value: tahsilat[today].Toplam, text: t('Toplam2'), icon: <DoneAllIcon /> },
                    ].map(item => item.value > 0 &&
                      <ListItem>
                        <ListItemIcon>
                          {item.icon}
                        </ListItemIcon>
                        <ListItemText primary={item.text} />
                        <ListItemSecondaryAction>
                          {item.value.toFixed(2)} TL
              </ListItemSecondaryAction>
                      </ListItem>
                    )}
                  </List>
                  <Divider className={classes.dividerD} />
                  <TableContainer component={Paper}>
                    <Table className={classes.tableD} size="small" aria-label="a dense table">
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">{t('Musteri')}</TableCell>
                          <TableCell>{t('FisNo')}</TableCell>
                          <TableCell>{t('Tahsilat')}</TableCell>
                          <TableCell align="right">{t('Tutar')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {todosData.filter(d => d.OperationStartDate === today).map(row => (
                          <TableRow key={row.WorkOrderId} onClick={() => history.push(`/WorkOrder/${row.WorkOrderId}/summary`)}>
                            <TableCell component="th" scope="row" align="left">{row.Consumer}</TableCell>
                            <TableCell>{row.WorkOrderId}</TableCell>
                            <TableCell>{row.Payment.substring(0, 5)}</TableCell>
                            <TableCell align="right">{row.Price.toFixed(2)}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <MoneyDisplay text={t('Toplam3')} value={(tahsilat[today].Toplam).toFixed(2)} />
                  <Divider className={classes.dividerD} />
                  {todosData.filter(d => d.Type === 3 && d.OperationStartDate === today).length > 0 &&
                    <div>
                      <TableContainer component={Paper}>
                        <Table className={classes.tableD} size="small" aria-label="a dense table">
                          <TableHead>
                            <TableRow>
                              <TableCell>{t('Musteri')}</TableCell>
                              <TableCell>{t('FisNo')}</TableCell>
                              <TableCell>{t('Tahsilat')}</TableCell>
                              <TableCell align="right">{t('Tutar')}</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {todosData.filter(d => d.Type === 3 && d.OperationStartDate === today).map(row => (
                              <TableRow key={row.WorkOrderId} className={classes.tableRow} onClick={() => history.push(`/WorkOrder/${row.WorkOrderId}/summary`)}>
                                <TableCell component="th" scope="row" align="left">{row.Consumer}</TableCell>
                                <TableCell>{row.WorkOrderId}</TableCell>
                                <TableCell>{row.Payment.substring(0, 5)}</TableCell>
                                <TableCell align="right">{row.Price.toFixed(2)}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      <MoneyDisplay text={t('Ek_Garanti')} value={tahsilat[today].EkGaranti.toFixed(2)} />
                    </div>
                  }
                  <Divider className={classes.dividerD} />
                  {todosData.filter(d => d.Type === 2 && d.OperationStartDate === today).length > 0 &&
                    <div >
                      <TableContainer component={Paper}>
                        <Table className={classes.tableD} size="small" aria-label="a dense table">
                          <TableHead>
                            <TableRow>
                              <TableCell>{t('Musteri')}</TableCell>
                              <TableCell>{t('FisNo')}</TableCell>
                              <TableCell>{t('Tahsilat')}</TableCell>
                              <TableCell align="right">{t('Tutar')}</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {todosData.filter(d => d.Type === 2 && d.OperationStartDate === today).map(rowUrun => (
                              <TableRow key={rowUrun.WorkOrderId} onClick={() => history.push(`/WorkOrder/${rowUrun.WorkOrderId}/summary`)}>
                                <TableCell component="th" scope="row" align="left">{rowUrun.Consumer}</TableCell>
                                <TableCell>{rowUrun.WorkOrderId}</TableCell>
                                <TableCell>{rowUrun.Payment.substring(0, 5)}</TableCell>
                                <TableCell align="right">{rowUrun.Price.toFixed(2)}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      <MoneyDisplay text={t('Tamamlayici_urun')} value={tahsilat[today].TamamlayiciUrun.toFixed(2)} />
                    </div>
                  }
                </CardContent> */}
        {/* </Card>
            </div>
          </div>
        </PullToRefresh> */}
      </Container>
    </Page>
  );
}

export default Tahsilat;
